import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { map, Observable, of } from "rxjs";
import { IResponseContent } from "../models/interfaces/responseContent.interface";
import { IServicesOptions, IStructureOptions } from "../models/interfaces/typology.interface";

@Injectable({
    providedIn: 'root'
})
export class TypologyService {

    private _httpClient: HttpClient = inject(HttpClient);

    //resituisce una lista di tutte le strutture senza filtri
    getTypologyStructure():Observable<IStructureOptions[]>{
        return this._httpClient.get<IResponseContent<IStructureOptions[]>>('/booking/establishment').pipe(
             map(({ content }) => content));
    }

    //resituisce una lista di tutte i servizi senza filtri
    getTypologyServices():Observable<IServicesOptions[]>{
        return this._httpClient.get<IResponseContent<IServicesOptions[]>>('/booking/service').pipe(
            map(({ content }) => content));

    }
}